import type { ReactNode } from "react";
import { createContext, useContext, useEffect, useState } from "react";

type SetBreadcrumbTitle = (title: string | null) => void;

// The title the open record page shows in its header, for the breadcrumb's last crumb.
const BreadcrumbTitleContext = createContext<string | null>(null);
const SetBreadcrumbTitleContext = createContext<SetBreadcrumbTitle>(() => undefined);

export const BreadcrumbTitleProvider = ({ children }: { children: ReactNode }) => {
  const [title, setTitle] = useState<string | null>(null);
  return (
    <SetBreadcrumbTitleContext.Provider value={setTitle}>
      <BreadcrumbTitleContext.Provider value={title}>{children}</BreadcrumbTitleContext.Provider>
    </SetBreadcrumbTitleContext.Provider>
  );
};

export const useBreadcrumbTitle = (): string | null => useContext(BreadcrumbTitleContext);

// Names the page's last crumb while the page is open.
export const useSetBreadcrumbTitle = (title: string | null | undefined): void => {
  const setTitle = useContext(SetBreadcrumbTitleContext);
  useEffect(() => {
    setTitle(title || null);
    return () => setTitle(null);
  }, [title, setTitle]);
};
